export default __webpack_public_path__ + "static/media/pallet.5cc7db1d.svg";